// extracted by mini-css-extract-plugin
module.exports = {"desginTueskminb":"InteriorServices_desginTueskminb__Ro_n0","designTurtiles":"InteriorServices_designTurtiles__iuXw7","comPletmainbox":"InteriorServices_comPletmainbox__shUcm"};